import qrDark from 'img/onboarding/qr-dark.png';
import qrLight from 'img/onboarding/qr-light.png';
import React, { type FC, useCallback } from 'react';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './OnboardingQRModal.css';

export interface OnboardingQRModalProps {
    onClose?(): void;
}

export const OnboardingQRModal: FC<OnboardingQRModalProps> = ({ onClose }) => {
    const renderHeader = useCallback(() => <h3 className={styles.title}>Приложение Облако Mail</h3>, []);
    const isDark = isDarkThemeModeEnabled();

    const renderContent = useCallback(
        () => (
            <div className={styles.content}>
                <p className={styles.description}>Наведите камеру на QR-код, чтобы установить мобильное приложение</p>
                <img className={styles.qr} src={isDark ? qrDark : qrLight} alt="скачать приложение" />
            </div>
        ),
        []
    );

    const handleClose = useCallback(() => {
        onClose?.();
    }, [onClose]);

    return (
        <BaseConfirmDialog
            size="average"
            dataQAId="onboarding-qr-modal"
            buttons={[]}
            renderContent={renderContent}
            renderHeader={renderHeader}
            onClose={handleClose}
        />
    );
};
